import { toCamelCaseProperties, propertiesToObject } from '@/utils/fn';
import { SearchAndCoverImage, TextAndImage, CallToAction, Banner, ScrollToDiv, CustomHTML, LastVisitedSalons } from '@/services/models';
import UmbracoBase from './UmbracoBase';

export default class FrontPage {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		let modulesArray = [];
		let modules = args.modules;

		modules.forEach(item => {
			let module = propertiesToObject(item);
			let moduleObj = {};

			switch (item.ContentType) {
				case 'soekOgForsidebilde':
					moduleObj = new SearchAndCoverImage(module);
					break;
				case 'mosaicImageComponent':
					moduleObj = new TextAndImage(module);
					break;
				case 'ctaComponent':
					moduleObj = new CallToAction(module);
					break;
				case 'bannerComponent':
					moduleObj = new Banner(module);
					break;
				case 'scrollToComponent':
					moduleObj = new ScrollToDiv(module);
					break;
				case 'customHTML':
					moduleObj = new CustomHTML(module);
					break;
				case 'lastVisitedSalons':
					moduleObj = new LastVisitedSalons(module);
					break;
				default:
					moduleObj = new UmbracoBase(module);
			}
			modulesArray.push(moduleObj);
		});

		this.modules = modulesArray;
	}
}
